<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">Stephen Jay retired from a successful career in the computer profession and started writing short stories and novellas. <em>The</em> <em>Illusion of Guilt</em> is his first novel and features a computer professional.</p><br/>
<p style="text-indent: 00em;">Stephen recently moved to Devon and enjoys going for long walks where he clarifies his plots. He also enjoys reading, composing music, and hunting for antiques.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?f244e204